// Your other code goes here
// import "controllers"
// import "bootstrap"
// import "controllers/announcements"
// import "controllers/activities"
// import "controllers/tables"
// import "controllers/hours"
// import "controllers/select2"
// import "datatables"
// ##### import "select2"

import "trix";
import "@rails/actiontext";

import './application.scss';
import { Tooltip, Toast, Popover } from 'bootstrap';
import "jquery";
import './js/hours';
import './js/announcements';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.js';

// Initialize Select2 on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  if ($.fn.select2) {
    $('.searchable_select').select2({
      theme: "bootstrap-5",
    });
    console.log('✅ Select2 initialized successfully via CDN!');
  } else {
    console.error('❌ Select2 still failed via CDN!');
  }

  if ($.fn.DataTable) {
    console.log('✅ DataTables loaded successfully!');

    $('#users_index').DataTable({
      "paging": false,
      dom: 'lBfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export CSV'
        }
      ]
    });

    $('#hours_table').DataTable({
      "paging": false,
      "aaSorting": [[ 2, "desc" ]],
      "lengthChange": true,
      "lengthMenu": [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
      dom: 'lBfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export CSV'
        }
      ]
    });

    $('#activities_table').DataTable({
      "paging": false,
      "lengthChange": true,
      "lengthMenu": [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
      dom: 'lBfrtip',
      buttons: [
        {
          extend: 'csv',
          text: 'Export CSV'
        }
      ]
    });

  
  } else {
    console.error('❌ DataTables failed to load!');
  }

  const resetButton = document.querySelector('#search input[type="reset"]');
  const form = document.getElementById('search');

  if (resetButton && form) {
    resetButton.addEventListener('click', (event) => {
      event.preventDefault(); // Prevent Turbo from interfering
      window.location.href = window.location.pathname;
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  console.log('JavaScript is loaded!');
});


document.addEventListener('DOMContentLoaded', () => {
  const dateStart = document.getElementById('date_start');
  const dateEnd = document.getElementById('date_end');

  // Helper function to format date as YYYY-MM-DD
  function formatDate(date) {
    return date.toISOString().split('T')[0];
  }

  // Function to set the start and end dates based on button click
  function setDateRange(option) {
    const today = new Date();
    let startDate, endDate;

    switch (option) {
      case 'last30':
        startDate = new Date();
        startDate.setDate(today.getDate() - 30);
        endDate = today;
        break;

      case 'mtd':
        startDate = new Date(today.getFullYear(), today.getMonth(), 1);
        endDate = today;
        break;

      case 'ytd':
        startDate = new Date(today.getFullYear(), 0, 1);
        endDate = today;
        break;

      default:
        console.warn('Invalid option selected');
        return;
    }

    dateStart.value = formatDate(startDate);
    dateEnd.value = formatDate(endDate);
  }

  // Add event listeners to buttons
  document.querySelectorAll('.date-preset-btn').forEach(button => {
    button.addEventListener('click', (event) => {
      setDateRange(event.target.dataset.preset);
    });
  });
});
